import { combineReducers } from 'redux';

import { RESET_STORE } from './common/types';

import userReducer from './user/reducer';
import restaurantReducer from './restaurant/reducer';
import commonReducer from './common/reducer';
import companyReducer from './company/reducer';
import ownerReducer from './owner/reducer';
import dishesReducer from './dishes/reducer';
import dishCategoryReducer from './dishes_categories/reducer';
import dishOptionsReducer from './dishes_options/reducer';
import settingsReducer from './settings/reducer';
import specialMenuReducer from './special_menu/reducer';

const appReducer = combineReducers({
  user: userReducer,
  restaurant: restaurantReducer,
  company: companyReducer,
  owner: ownerReducer,
  common: commonReducer,
  dishes: dishesReducer,
  dish_category: dishCategoryReducer,
  dish_option: dishOptionsReducer,
  settings: settingsReducer,
  special_menu: specialMenuReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
